import {
    GET_CUSTOMERS_REQUEST,
    GET_CUSTOMERS_SUCCESS,
    GET_CUSTOMERS_FAILURE
} from '../constants/';

const INIT_STATE = {
    isLoading: false,
    isInitialFetch: true,
    data: [],
    error: null,
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_CUSTOMERS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case GET_CUSTOMERS_SUCCESS:
            console.log('disptach success, ', action.payload)
            return {
                ...state,
                isLoading: false,
                data: action.payload.customers,
                isInitialFetch: false,
            };
        case GET_CUSTOMERS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error.stack,
            };
        default:
            return state;
    }
};